import { Input } from 'antd';
import styled from 'styled-components';
import { Alert } from 'components/atoms/alert';
import { ProductiveHeading05 } from 'components/styles';

const { TextArea } = Input;

export const EditorHeading = styled(TextArea)`
  ${ProductiveHeading05};
  padding: 0 var(--spacing-03) 0 0;
  background: transparent;
  border: none;
  resize: none;
  box-shadow: none !important;
  &:read-only {
    cursor: default;
  }
`;

export const HeaderAlert = styled(Alert)`
  border: 1px transparent;
`;

export const Container = styled.div`
  background: var(--coolest-gray-10);
  padding: var(--spacing-06);
`;

export const ToastContainer = styled.div`
  .ant-notification-notice-message,
  .ant-notification-notice-description {
    margin-left: var(--spacing-07);
  }
  .ant-notification-notice-message {
    font-weight: var(--font-weight-bold);
  }
`;

export const Head = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const PublishBtn = styled.div`
  margin-right: var(--spacing-03);
`;

export const ActionsDisabled = styled.div`
  pointer-events: none;
  display: flex;
  align-items: center;
`;

export const Avatar = styled.div`
  padding: var(--spacing-06) var(--spacing-02) var(--spacing-04) 0;
  display: flex;
  align-items: center;
  color: var(--gray-70);
`;
